import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { ActionText } from '@components/action-text';
import { Button } from '@components/button';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';

import { Box } from 'components/Box';
import { UnauthedPage } from 'components/unauthed-page';

export const SigninTwoFactor = observer((props) => {
  const { code, onChange, onSubmit, error, disableSubmit, useSms, sendingSMS, t } = props;

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      onSubmit();
    }
  }

  let submitLabel = disableSubmit
    ? t('signin.twofactor.button.submitting')
    : t('signin.twofactor.button.submit');

  return (
    <UnauthedPage>
      <Text font="heading1">{t('signin.twofactor.heading')}</Text>
      <Text>{t('signin.twofactor.subheading')}</Text>
      <Box mt="24">
        <TextField
          label={t('signin.twofactor.label.code')}
          value={code}
          error={error}
          onChange={(val) => onChange('code', val)}
          isDisabled={disableSubmit}
          onKeyPress={handleKeyPress}
        />
      </Box>
      <Actions justifyContent="space-between" alignItems="center" mt="24">
        <Button
          isDisabled={disableSubmit}
          onClick={onSubmit}
          text={sendingSMS ? t('signin.twofactor.button.sendingsms') : submitLabel}
        />
        <ActionText.Link font="regular14" color="purple40" onClick={useSms}>
          {t('signin.twofactor.sms')}
        </ActionText.Link>
      </Actions>
    </UnauthedPage>
  );
});

const Actions = styled(Box)((p) => ({
  display: 'flex',
  [p.theme.mobileQuery]: {
    display: 'block',
    '> *': {
      textAlign: 'center',
      width: '100%',
    },
    '> a': {
      display: 'block',
      marginTop: p.theme.spacing.m12,
    },
  },
}));
